import $ from 'jquery'

/**
 * Generate a table of content
 */
export default function toc (options = {}) {
    const defaultOptions = {
        contentElementId: 'toc-content',
        tocElementId: 'toc',
        listTag: 'ul',
        listClass: '',
        anchorClass: 'nav-link',
        headings: 'h2, h3, h4',
        scrollspy: false,
        scrollspyOffset: 100
    }
    options = Object.assign(defaultOptions, options)

    const $toc = $('#' + options.tocElementId)
    const $tocContent = $('#' + options.contentElementId)
    const headingSelectors = options.headings.split(',')
    const headings = $tocContent.find(options.headings)

    let currentLevel = 0

    if ($toc.length && $tocContent.length) {
        $toc.append($('<' + options.listTag + '>', { class: options.listClass }))
        const stack = [$toc.find(options.listTag)]

        headings.each(function () {
            const $this = $(this);
            const headingText = $this.text()
            const anchor = headingText
                .normalize('NFD')
                .replace(/(&nbsp;)|(<|&lt;)br\s*\/*(>|&gt;)|[^a-zA-Z\d\s’]/g, '')
                .trim()
                .replace(/\s|’/g, '-')
                .toLowerCase()

            // add anchor to title
            $this.attr('id', anchor)

            // create list item
            let $item = $('<a>', { href: '#' + anchor, class: options.anchorClass, text: headingText.trim() })
            if (options.listTag === 'ul') {
                $item = $('<li>', { class: 'nav-item' }).append($item)
            }

            const  level = $.map(headingSelectors, function (selector, index) {
                return $this.is(selector) ? index : undefined
            })[0]

            if (level > currentLevel) {
                const parentItem = stack[0].children('li:last')[0]
                if (parentItem) {
                    stack.unshift($('<' + options.listTag + '>', { class: options.listClass }).appendTo(parentItem))
                }
            } else {
                stack.splice(0, Math.min(currentLevel - level, Math.max(stack.length - 1, 0)))
            }

            // Add the list item
            $item.appendTo(stack[0])

            currentLevel = level
        })

        if (options.scrollspy) {
            $('body').scrollspy({
                target: '#' + options.tocElementId,
                offset: options.scrollspyOffset
            })
        }
    }
}